import React from 'react';

const Footer = () => {
  return (
    <footer id="footer" className="footer dark-background">
    <div className="footer-top">
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="/" className="logo d-flex align-items-center">
              <span className="sitename" style={{color: 'green'}}>Zao Afrika</span>
            </a>
            <div className="footer-contact pt-3">
              <p>Nairobi, Kenya</p>
              <p>Enterprise Road, Industrial Area</p>
              <p className="mt-3"><strong>Phone:</strong> <span>+254 759 647 078</span></p>
              <p><strong>Email:</strong> <span>zaoafrika@gmail.com</span></p>
            </div>
          </div>
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About us</a></li>
              <li><a href="/service">Services</a></li>
              <li><a href="/contact">Contact</a></li>
              <li><a href="/blog">News & Updates</a></li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><a href="/service">Contract Farming</a></li>
              <li><a href="/service">Harvest Solutions</a></li>
              <li><a href="/service">Market Access</a></li>
              <li><a href="/service">Supply Chain Solutions</a></li>
              <li><a href="/service">Agricultural Finance</a></li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>For Farmers</h4>
            <ul>
              <li><a href="/contact">Training Programs</a></li>
              <li><a href="/blog">Resource Center</a></li>
              <li><a href="/blog">Market Prices</a></li>
              <li><a href="/testimonials">Success Stories</a></li>
              <li><a href="/contact">Partner With Us</a></li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Resources</h4>
            <ul>
              <li><a href=" ">FAQs</a></li>
              <li><a href="/contact">Support Center</a></li>
              <li><a href=" ">Terms of Service</a></li>
              <li><a href=" ">Privacy Policy</a></li>
              
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div className="copyright text-center">
      <div className="container d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between align-items-center">
        <div className="d-flex flex-column align-items-center align-items-lg-start">
          <div>
            © Copyright <strong><span style={{color: '#ADD8E6'}}>Maglev Tech Afrika</span></strong>. All Rights Reserved
          </div>
          <div className="credits">
            Empowering Chia Seed Farmers in Africa
          </div>
        </div>
        <div className="social-links order-first order-lg-last mb-3 mb-lg-0">
          <a href=" "><i className="bi bi-twitter-x" /></a>
          <a href=" "><i className="bi bi-facebook" /></a>
          <a href=" "><i className="bi bi-instagram" /></a>
          <a href=" "><i className="bi bi-linkedin" /></a>
        </div>
      </div>
    </div>
  </footer>
  );
};

export default Footer;